import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100%",
    overflow: "hidden",
    padding: "2rem",
    background: "linear-gradient(180deg, #00351A 0%, #1B1B1B 100%)",
    "@media (max-width: 500px)": {
      padding: "0.5rem",
    },
  },
  container: {
    padding: "39px",
    borderRadius: "16px",
    backgroundColor: "#00351A",
    "@media (max-width: 650px)": {
      padding: "4px",
    },
  },
  margincont: {
    backgroundColor: "#001E0F",
    padding: "39px",
    borderRadius: "16px",
    "@media (max-width: 600px)": {
      padding: "1rem",
    },
  },
  mainpage: {
    maxWidth: "628px",
    margin: "auto",
    textAlign: "center",
    color: "#FFF",
    "& p": {
      fontSize: "20px",
      marginBlock: "0px",
      lineHeight: "140%",
    },
    "& h2": {
      fontSize: "32px",
      fontWeight: 700,
      marginBlock: "0px 13px",
    },
  },
  boldImage: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
    marginBottom: "1rem",
    zIndex: 10,
    position: "relative"
  },
  heading: {
    fontWeight: "bold",
    fontSize: "1.8rem",
    textAlign: "center",
    marginBottom: "2rem",
  },
  itemWrapper: {
    maxWidth: "1420px",
    margin: "0 auto",
    position: "relative",
    zIndex: "20"
  },
  blurbcg: {
    width: "30%",
    height: "300px",
    borderRadius: "50%",
    background: "rgba(65, 112, 88, 1)",
    filter: "blur(140px)",
    position: "absolute",
    top: "77%",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1,
  },
  card: {
    borderRadius: "16px",
    marginBottom: "14px",
    padding: "24px",
    backgroundColor: "#FFFFFF",
    transition: "all 0.3s ease-in-out",
    "& h4": {
      fontSize: "20px",
      fontWeight: 700,
      marginBlock: "0px 8px",
    },
    "& p": {
      fontSize: "16px",
      lineHeight: "140%",
      color: "#333333",
      marginBlock: "0px",
    },
  },
  forcardinal: {
    "& img": {
      width: "100%"
    }
  },
  imgcard: {
    borderRadius: "16px",
    marginBottom: "14px",
    padding: "24px",
    color: "#FFFFFF",
    transition: "all 0.3s ease-in-out",
    "& h4": {
      fontSize: "20px",
      fontWeight: 700,
      marginBlock: "0px 8px",
    },
    "& p": {
      fontSize: "16px",
      lineHeight: "140%",
      marginBlock: "0px",
    },
    "@media (max-width: 600px)": {
      padding: "0.8rem",
    },
  },
  rightcard: {
    borderRadius: "16px",
    marginBottom: "14px",
    padding: "24px",
    color: "#FFFFFF",
    transition: "all 0.3s ease-in-out",
    background: "linear-gradient(180deg, #00351A 0%, #082617 100%)",
    height: "85%",
    "& h4": {
      fontSize: "20px",
      fontWeight: 700,
      marginBlock: "0px 8px",
    },
    "& p": {
      fontSize: "16px",
      lineHeight: "140%",
      marginBlock: "0px",
    },
  },
  bottomcard: {
    borderRadius: "16px",
    marginBottom: "14px",
    padding: "20px 20px 44px 20px",
    color: "#FFFFFF",
    background: "linear-gradient(180deg, #191D1B 0%, #00351A 100%)",
    transition: "all 0.3s ease-in-out",
    "& h4": {
      fontSize: "20px",
      fontWeight: 700,
      marginBlock: "0px 8px",
    },
    "& h2": {
      fontSize: "20px",
      fontWeight: 700,
      marginBlock: "0px 10px"
    },
    "& p": {
      fontSize: "16px",
      lineHeight: "140%",
      marginBlock: "0px",
    },
  },
}));

export default useStyles;
